import request from '../../utils/request.js'
export function getHotProblem(params){
    return request({
        url:"/owsArticle/findArticleCommonQuestion",
        method:'get',
        params
    })
}
